import { createSelector } from '@reduxjs/toolkit';
import { userPropertiesForCurrentOrganization } from 'src/store/selectors';

export const isUserEmergencyMode = createSelector(
  [userPropertiesForCurrentOrganization],
  function (userProperties): boolean {
    return userProperties.isUserEmergencyMode || false;
  },
);
